import { render } from "./QuickTabsPane.vue?vue&type=template&id=9bb89a20&scoped=true"
import script from "./QuickTabsPane.vue?vue&type=script&lang=js"
export * from "./QuickTabsPane.vue?vue&type=script&lang=js"

import "./QuickTabsPane.vue?vue&type=style&index=0&id=9bb89a20&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb89a20"]])

export default __exports__